import { memo } from 'react'
import { RadioGroup as MuiRadioGroup, RadioGroupProps as MuiRadioGroupProps } from '@mui/material'
import styled from 'styled-components'

export type RadioGroupPropsType = MuiRadioGroupProps

const RadioGroup = styled(MuiRadioGroup)<RadioGroupPropsType>``

export default RadioGroup
export const RadioGroupMemoized = memo(RadioGroup)
